const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

//Action to save and fetch data
import { fetchtopten, fetchposts, frontimmute } from '../../actions/front_actions';

//Import Designs
import ReactPlayer from 'react-player/lazy';
import { encode } from 'html-entities';

import { Link, Grid2, Card, CardMedia, Typography } from '@mui/material';

class Photoleader extends Component {
    constructor(props) {
        super(props);
        this.state = { anchorEl: '', wait: 0 };
    }

    componentDidMount = () => {
        this.setState({ wait: 1 });
        let wpvc_search = '';
        let author = '';
        if (this.props.author_id != '' && typeof this.props.author_id != "undefined") {
            this.setState({ authorid: this.props.author_id });
            author = this.props.author_id;
        }
        this.props.fetchposts(this.props.SITE_URL, this.props.short.id, this.props.short, 1, "", wpvc_search, author);
        setTimeout(function () {
            this.setState({ wait: 0 });
        }.bind(this), 1000);
    }

    render() {
        const { t, i18n } = this.props;
        const xs_row = 12;
        let allprops = this.props;
        let posts = null;
        if ((typeof this.props.post !== "undefined") && this.props.post != null) {
            posts = this.props.post.posts;
        }

        let contest_type = null;
        if (typeof allprops.short.allcatoption !== "undefined") {
            contest_type = this.props.short.contest_type;
        }

        let audio_upload = (typeof allprops.short.allcatoption !== "undefined") ? allprops.short.allcatoption.musicfileenable : null;
        let video_height = '250';
        let music_height = '250';
        let displayphoto = allprops.short.display_photo;
        let displaycat = allprops.short.display_category;
        let displayauthor = allprops.short.display_author;

        if ((posts != null && typeof posts === 'object') && (this.state.wait != 1) && (posts.length > 0)) {
            return (
                (<Grid2 container className="wpvc_widget_photo_container">
                    <Grid2 container size={12} direction="row" className="wpvc_show_style">
                        {displaycat == 1 &&
                            <Typography variant="h5" className="wpvc_card_widget_cat_name">
                                {allprops.short.title}
                            </Typography>
                        }
                        {posts.map((object, i) =>
                            <Grid2 key={i} className="wpvc_show_style_row_leader_widget" size={parseInt(xs_row)}>

                                <Card className="wpvc_card_row">
                                    {displayphoto == 1 &&
                                        <div>
                                            {contest_type != null && (contest_type == "photo" || contest_type == "essay") &&
                                                <Link href={object.link} className="wpvc_image_popup_modal">
                                                    <CardMedia className={"wpvc_card_media_row"} image={object.featured_image_url} title={object.post_title} />
                                                </Link>
                                            }

                                            {
                                                contest_type != null && (contest_type == "video") && object.custom_fields_value["contestant-ow_video_url"].includes("www.bitchute.com") &&
                                                <iframe width="100%" className="bitchute_video" scrolling="no" allowFullScreen={true} height={video_height} frameborder="0" src={encode(object.custom_fields_value["contestant-ow_video_url"].replace("video", "embed"))}></iframe>

                                            }
                                            {
                                                contest_type != null && (contest_type == "video") && object.custom_fields_value["contestant-ow_video_url"].includes("www.instagram.com") &&
                                                <div className="wpvc_instagram_parent_div">
                                                    <iframe
                                                        className="wpvc_instagram-media instagram-media-rendered"
                                                        id={"instagram-embed-" + object.id}
                                                        src={encode(object.custom_fields_value["contestant-ow_video_url"]) + "embed/captioned"}
                                                        height={video_height}
                                                        frameborder="0" scrolling="no" allowtransparency="true" allowFullScreen={true}
                                                    ></iframe>
                                                </div>

                                            }
                                            {
                                                contest_type != null && (contest_type == "video") && object.custom_fields_value["contestant-ow_video_url"].includes("www.tiktok.com") &&
                                                <div className="wpvc_tiktok_parent_div">
                                                    <iframe className="tiktok_video" scrolling="no" allowFullScreen={true} width='100%' height={video_height} frameborder="0" src={"https://www.tiktok.com/embed/" + new URL(object.custom_fields_value["contestant-ow_video_url"]).pathname.substring(new URL(object.custom_fields_value["contestant-ow_video_url"]).pathname.lastIndexOf('/') + 1)}></iframe>
                                                </div>
                                            }
                                            {contest_type != null && (contest_type == "video") && !object.custom_fields_value["contestant-ow_video_url"].includes("www.bitchute.com") && !object.custom_fields_value["contestant-ow_video_url"].includes("www.tiktok.com") && !object.custom_fields_value["contestant-ow_video_url"].includes("www.instagram.com") &&
                                                <ReactPlayer url={encode(object.custom_fields_value["contestant-ow_video_url"])}
                                                    playing={false} width="100%"
                                                    height={video_height + 'px'}
                                                    controls={true}
                                                    className={(contest_type == 'music') ? "wpvc_music_contest_player" : "wpvc_video_contest_player"}
                                                />

                                            }
                                            {contest_type != null && (contest_type == "music") &&
                                                <ReactPlayer url={(audio_upload == 'off') ? encode(object.custom_fields_value["contestant-ow_music_url_link"]) : encode(object.custom_fields_value["contestant-ow_music_url"])}
                                                    playing={false} width="100%"
                                                    height={music_height + 'px'}
                                                    controls={true}
                                                    className={(contest_type == 'music') ? "wpvc_music_contest_player" : "wpvc_video_contest_player"}
                                                />
                                            }
                                        </div>
                                    }
                                    {displayphoto == 0 &&
                                        <div className="wpvc_no_photo_leader_widget"></div>
                                    }
                                    <Grid2 className="wpvc_leader_contents">
                                        <Link className="wpvc_leader_title" href={object.link}>{object.post_title}</Link>
                                        {displayauthor == 1 &&
                                            <Typography className="wpvc_card_widget_author_name">
                                                {(object.author_name != '') ? t("by") : ''}{object.author_name}
                                            </Typography>
                                        }

                                        <div className="wpvc_card_widget_vote_count">
                                            <div className="wpvc_card_widget_vote_count_child">
                                                <span>{object.votes_count}</span>
                                                <span>{t("votes")}</span>
                                            </div>
                                        </div>

                                    </Grid2>
                                </Card>

                            </Grid2>
                        )}

                    </Grid2>
                </Grid2>)
            );
        } else {
            return '';
        }

    }
}

const settingstate = state => {
    return { post: state.wpvcfrontdata };
}

export default connect(settingstate, { frontimmute, fetchposts, fetchtopten })(withTranslation("translations")(Photoleader));

